import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CommunicationService } from '../../services/communication.service';
import { LoginService } from '../../services/login.service';
import { MyRemaxModes } from '../../classes/enums';
import { HasSubscriptions } from '../has-subscriptions';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent extends HasSubscriptions implements OnInit {
  @Input() showLeftNav: boolean = false;
  @Input() showRightNav: boolean = false;
  @Output() changeRoute: EventEmitter<void> = new EventEmitter();

  constructor(private router: Router,
    private communicationService: CommunicationService,
    private _loginService: LoginService) {
      super();
  }

  ngOnInit() {}

  logout() {
    this.communicationService.navigation.toggleNavs.next({left: false, right: false});
    this.addSub(this._loginService.logout()
      .subscribe(r => {
        // Do nothing, fire and forget
      }));
    const queryIndex = this.router.url.indexOf('?');
    const url = queryIndex === -1 ? this.router.url : this.router.url.substring(0, queryIndex);
    this.router.navigate([url]);
  }

  async toSavedSearches($event) {
    this.showRightNav = false;
    await this.router.navigate(['/my-remax'], {queryParams: {mode: MyRemaxModes.SAVED_SEARCHES }});
    this.changeRoute.emit();
  }

  async toFavourites($event) {
    this.showRightNav = false;
    await this.router.navigate(['/my-remax'], {queryParams: { mode: MyRemaxModes.FAVOURITES }});
    this.changeRoute.emit();
  }

  async toMyAccount(event) {
    this.showRightNav = false;
    await this.router.navigate(['/my-account']);
    this.changeRoute.emit();
  }

  async openSignIn($event) {
    this.communicationService.showSignIn.next(true);
    // this.changeRoute.emit();
  }

  async toFavouriteAgent($event: string) {
    this.showRightNav = false;
    await this.router.navigate([$event]);
    this.changeRoute.emit();
  }

  closeLeftNav() {
    this.showLeftNav = false;
    this.communicationService.navigation.toggleNavs.next({left: false, right: false});
  }

  closeRightNav() {
    this.showRightNav = false;
    this.communicationService.navigation.toggleNavs.next({left: false, right: false});
  }
}
